export var CommissionStatusCodes;
(function(CommissionStatusCodes) {
    CommissionStatusCodes[CommissionStatusCodes["STATUS_DELETED"] = -2] = "STATUS_DELETED";
    CommissionStatusCodes[CommissionStatusCodes["STATUS_CREATED"] = -1] = "STATUS_CREATED";
    CommissionStatusCodes[CommissionStatusCodes["STATUS_ACTIVE"] = 1] = "STATUS_ACTIVE";
})(CommissionStatusCodes || (CommissionStatusCodes = {}));
export var CommissionStatusType;
(function(CommissionStatusType) {
    CommissionStatusType["ACTIVE"] = "active";
    CommissionStatusType["DISABLED"] = "disabled";
})(CommissionStatusType || (CommissionStatusType = {}));
export const CommissionStatusCodeMap = {
    ["active"]: 1,
    ["disabled"]: -1
};
export const CommissionStatusMap = {
    [1]: "active",
    [-1]: "disabled"
};

//# sourceMappingURL=commissions.js.map